import { SECURE_DATA_SETTINGS } from '@store/slices/resources';

export const secureDataSettingsInitialSelector = state =>
  state[SECURE_DATA_SETTINGS].initialValue;
